import { Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Location} from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'fury-role-add-edit',
  templateUrl: './role-add-edit.component.html',
  styleUrls: ['./role-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class RoleAddEditComponent implements OnInit, OnDestroy {
  roleForm!:FormGroup;
  roleData:any;
  roleId: any;
  menuList!:any;
  selectedCheckBoxList: any = [];
  acl:any = [];
  disabled!: boolean;
  rolList = [];
  roleType = null;
  ngUnsubscribe = new Subject<void>();
  removeMenuIds = [];
  constructor(
    private apiService: ApiService,
    public location: Location,
    private activateRoute: ActivatedRoute
  ) {
    this.roleId = this.activateRoute.snapshot.params["id"];
    this.activateRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: any)=> {
        this.roleType = res?.roleType === 'claim' ? 'claim' : null;
      }
    })
  this.getAllMenuList();
}

  ngOnInit(): void {
    this.formInit();
    this.getRoleList();
    this.roleForm.get('isAdmin')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
     if(res){
      this.menuList.forEach((obj: any)=> {
        if(obj?.title === "Partner Dashboard" || obj?.title === "Claim Dashboard") {
          this.removeMenuIds.push(obj?.adminMenuId);
          obj.checked = false;
          if(obj.children) this.childChange(obj, false);
        } else {
          obj.checked = true;
          if(obj.children) this.childChange(obj, true);
        }
      })
      let allAdminMenuId = this.getIdFields(this.menuList);
      allAdminMenuId = allAdminMenuId.filter(id => !this.removeMenuIds.includes(id));
      this.apiService.setRoleIdWithArryForm(allAdminMenuId);
      this.disabled = true;
     } else {
      this.menuList.forEach((obj: any)=> {
        obj.checked = false;
        if(obj.children) this.childChange(obj, false);
      })
      this.apiService.clearRoleID();
      this.disabled = false;
     }
    })
  }
  formInit(){
    this.roleForm = new FormGroup({
      title: new FormControl<string>('', [Validators.required]),
      description: new FormControl<string>('', [Validators.required]),
      isAdmin: new FormControl('', [Validators.required]),
      adminMenuIds: new FormArray([]),
      parentId: new FormControl<string>(''),
      manager: new FormControl<boolean>(false),
      statistics: new FormControl<boolean>(false),
      viewOnly: new FormControl<boolean>(false),
      type: new FormControl<string>('', [Validators.required])
    })
  };
  getRoleDetails(){
    this.apiService.get(`admin/role/get-role/${this.roleId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res : any) => {
      if(res?.body?.role){
        this.roleForm.patchValue(res?.body?.role);
        this.roleForm.get('parentId').setValue(res?.body?.role?.parent ? res?.body?.role?.parent?.roleId : '');
        this.acl = res?.body?.role?.acl;
        let dataWithId = this.acl.map((res:any)=>{
          this.apiService.setRoleID(res?.adminMenuId);
          return res.adminMenuId;
        })
        
        this.menuList.forEach((obj: any) => {
          let matchedItem = this.acl.find((item: any) => item.adminMenuId === obj.adminMenuId);
          if (matchedItem) {
            obj.checked = true;
            if(obj.children) this.setChildrenChecked(obj);
          } 
        });
      }
    })
  }
  getIdFields(data: any) {
    return data.reduce((result: any, item: any) => {
        result.push(item.adminMenuId);
        if (item.children.length > 0) {
            const childrenIds = this.getIdFields(item.children);
            result.push(...childrenIds);
        }
        return result;
    }, []);
}
  childChange(menu: any, type: boolean){
    menu.children.map((item: any)=>{
      item.checked = type;
      if(menu.children) this.childChange(item, type);
    })
  }
  setChildrenChecked(menu: any){
    menu.children.map((item:any) => {
      let matchedItem = this.acl.find((subItem: any) => item.adminMenuId === subItem.adminMenuId);
          if (matchedItem) {
            item.checked = true;
            if(item.children) this.setChildrenChecked(item);
          }
    })
  }
  addEditRole(){
    if(this.roleForm.valid){
      let data = this.roleForm.value;
      data.adminMenuIds = this.apiService.getRoleID().filter((item: any)=> item !== null && item !==undefined);
      if(!this.roleId){
        this.apiService.post('admin/role/create-role', data).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        });
      } else {
        this.apiService.patch(`admin/role/update-role/${this.roleId}`, data).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        })
      }   
       
    } else {
      this.roleForm.markAllAsTouched();
    }
  };
  getAllMenuList(){
    this.apiService
      .get(`admin/admin-menu/get-admin-menus?page=1&size=9999&withSubMenu=1`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
        if (res.body) {
          if (res?.body?.adminMenus.data) {
            this.menuList = [];
            const menu = res?.body?.adminMenus.data;
           
            menu.forEach((ele) =>{
              if(!ele.children.length){
                this.menuList.push(ele);
              }
            })
            menu.forEach((ele) =>{
              if(ele.children.length){
                this.menuList.push(ele);
              }
            })
           
            this.menuList.forEach(() => this.control.push(new FormControl()))
            
            if(this.roleId){
              this.getRoleDetails();
            } 
          }
        }
      });
  }
  get control() {
    return this.roleForm.get('adminMenuIds') as FormArray;
  }
  restrictSpace(event: any) {
    if (event.target.value.match(/\s/g)) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  }

  parentSelectionChange(event: any, item: any) {
    item.checked = event.target.checked;
    if(item.children) this.modifyChildren(item.children, event.target.checked);
      event.target.checked ? this.apiService.setRoleID(item.adminMenuId) : this.apiService.removeRoleID(item.adminMenuId);
  }

  modifyChildren(childrenData: any, checked: boolean) {
    childrenData.map((item: any) =>{
      item.checked = checked;
      item.checked ? this.apiService.setRoleID(item.adminMenuId) : this.apiService.removeRoleID(item.adminMenuId);
      if(item.children.length > 0) {
        this.modifyChildren(item.children, checked);
      }
    })
  }

  checkedParent(event: boolean, parent: any) {
    if(parent.children.every((x: any) => !x.checked)) {
      parent.checked = false;
      this.apiService.removeRoleID(parent.adminMenuId)
    } else {
      parent.checked = true;
      this.apiService.setRoleID(parent.adminMenuId)
    }
  }
  getRoleList() {
    this.apiService
      .get(
        `admin/role/get-all-roles?page=1&size=9999&isParent=1`
      ).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res.body) {
          if (res.body.roles.data) {
            this.rolList = res.body.roles.data;
            if(!this.roleId && this.roleType === 'claim'){
              this.findClaimRoleId();
            }
          }
        }
      }, (err: HttpErrorResponse)=>{
        this.apiService.alert(err.message, ErrorType.Error);
      });
  }
  findClaimRoleId(){
    const claim  = this.rolList.find(item => item?.title.toLowerCase() === 'claims');
    if(claim) {
      this.roleForm.get("parentId").setValue(claim?.roleId);
    }
  }

  ngOnDestroy(): void {
    this.apiService.clearRoleID();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
